<template>
    <modal @close="$emit('close')" :show-title="true" :size="'medium'">
        <div slot="header">
            <h5 class="modal-title">{{$t('carrello_indirizzo_consegna')}}</h5>
        </div>
        <div slot="body">
            <div class="alert alert-danger" role="alert" v-if="this.errors.length">
                <ul>
                    <li v-for="error in this.errors">{{error}}</li>
                </ul>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <input v-model="form.indirizzo" type="text"
                               class="form-control" :placeholder="$t('account.via')">
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <input v-model="form.numero"
                               type="text"
                               class="form-control" :placeholder="$t('account.civico')">
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <input type="text" v-model="form.campanello"
                               class="form-control"
                               :placeholder="$t('account.campanello')">
                    </div>
                </div>
                <div class="col-md-6"
                     v-if="this.deliveryConfiguration.tipo_modalita_zone === 'MANUALE'">
                    <div class="form-group">
                        <select v-model="form.id_consegna_citta"
                                class="form-control">
                            <option value="">{{$t('account.sel_city')}}</option>
                            <option v-for="option in this.deliveryCities"
                                    :value="option.id">
                                {{option.nome}}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-6"
                     v-if="this.deliveryConfiguration.tipo_modalita_zone === 'MANUALE'">
                    <div class="form-group">
                        <select v-model="form.id_consegna_zona"
                                class="form-control"
                                :disabled="!this.city_zones.length">
                            <option value="">{{$t('account.sel_cap')}}</option>
                            <option v-for="option in this.city_zones"
                                    :value="option.id">
                                {{option.nome}}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-12"
                     v-if="this.deliveryConfiguration.tipo_modalita_zone === 'COORDINATE'">
                    <div class="form-group">
                        <input type="text" v-model="form.localita_citta"
                               class="form-control"
                               :placeholder="$t('account.citta')">
                    </div>
                </div>
                <div class="col-md-3"
                     v-if="this.deliveryConfiguration.tipo_modalita_zone === 'COORDINATE'">
                    <div class="form-group">
                        <input type="text" v-model="form.provincia"
                               class="form-control"
                               :maxlength="this.province_length"
                               :placeholder="$t('account.prv')">
                    </div>
                </div>
                <div class="col-sm-3"
                     v-if="this.deliveryConfiguration.tipo_modalita_zone === 'COORDINATE'">
                    <div class="form-group">
                        <input type="text" v-model="form.cap_citta"
                               class="form-control"
                               :placeholder="$t('account.cap')">
                    </div>
                </div>
                <div class="col-sm-6"
                     v-if="this.deliveryConfiguration.tipo_modalita_zone === 'COORDINATE'">
                    <div class="form-group">
                        <select v-model="form.nazione" class="form-control" @change="truncateProvince">
                            <option value="">{{$t('account.sel_country')}}</option>
                            <option v-for="country in this.countries"
                                    :value="country.iso">
                                {{country.traduzione_ll.nome}}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                        <textarea v-model="form.note" class="form-control"
                                  :placeholder="$t('note')"></textarea>
                    </div>
                </div>
                <div class="col-md-12">
                    <mcw-checkbox v-model="form.predefinito">
                        &nbsp; <i>{{$t('carrello_ind_predefinito')}}</i>
                    </mcw-checkbox>
                </div>
            </div>
        </div>
        <div slot="footer" class="flex-fill d-flex justify-content-between">
            <button type="button" class="btn btn-default w-auto" @click="$emit('close', false)">
                {{$t('btn_annulla')}}
            </button>
            <button type="button" class="btn btn-primary w-auto" @click="submit()"
                    :disabled="this.saving">
                <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" v-if="this.saving"></span>
                {{$t('btn_salva')}}
            </button>
        </div>
    </modal>
</template>

<script>
    import {mapState} from 'vuex';
    import {newDeliveryAddress} from "../../../api/account";

    import Modal from "../../partials/Modal";

    export default {
        name: "ModalAddress",
        components: {Modal},
        props: ['deliveryCities', 'deliveryConfiguration', 'address', 'orderAddress', 'countries'],
        data() {
            return this.initData();
        },
        created() {
            if (!this.form.nazione) {
                this.form.nazione = this.locale.stato;
            }
        },
        computed: {
            selected_delivery_city: function () {
                return this.deliveryCities.find((city) => {
                    return city.id === this.form.id_consegna_citta;
                });
            },
            city_zones: function () {
                if (this.selected_delivery_city) {
                    return this.selected_delivery_city.zone;
                }

                return [];
            },
            province_length: function () {
                if (this.form.nazione === 'IT') {
                    return 2
                }

                return null;
            },
            ...mapState('localization', {
                language: state => state.language
            }),
            ...mapState('auth', {
                user: state => state
            }),
            ...mapState('restaurant', {
                id_ristorante: state => state.id,
                locale: state => state.locale
            })
        },
        watch: {
            'form.id_consegna_citta': function (oldval, newval) {
                if (oldval !== newval) {
                    this.form.id_consegna_zona = '';
                }
            },
        },
        methods: {
            initData: function () {
                const data = {
                    form: {
                        indirizzo: '',
                        numero: '',
                        campanello: '',
                        id_consegna_citta: '',
                        id_consegna_zona: '',
                        note: '',
                        //COORDINATE
                        localita_citta: '',
                        provincia: '',
                        cap_citta: '',
                        nazione: '',

                        predefinito: false,

                        old_id: null,
                    },
                    saving: false,
                    errors: []
                };

                if (this.address) {
                    //Modifica
                    data.form.indirizzo = this.address.indirizzo;
                    data.form.numero = this.address.numero;
                    data.form.campanello = this.address.campanello;
                    data.form.id_consegna_citta = this.address.id_consegna_citta;
                    data.form.id_consegna_zona = this.address.id_consegna_zona ? this.address.id_consegna_zona : '';
                    data.form.note = this.address.note;
                    //COORDINATE
                    data.form.localita_citta = this.address.localita_citta;
                    data.form.provincia = this.address.provincia;
                    data.form.cap_citta = this.address.cap_citta;
                    data.form.nazione = this.address.nazione;
                    data.form.predefinito = !!this.address.predefinito;
                    data.form.old_id = this.address.id;
                }

                return data;
            },
            truncateProvince: function () {
                if (this.province_length) {
                    this.form.provincia = this.form.provincia.substr(0, this.province_length);
                }
            },
            submit: function () {
                this.errors = [];
                this.saving = true;
                newDeliveryAddress(this.language, {
                    id_ristorante: this.id_ristorante,
                    id_locale: this.id_locale,
                    api_key: this.user.api_key,
                    email: this.user.email,
                    tipo: this.deliveryConfiguration.tipo_modalita_zone,
                    ordine_indirizzo: this.orderAddress,
                    ...this.form
                }).then((response) => {
                    this.$emit('close', response.indirizzo);
                }).catch(({messages}) => {
                    this.errors = messages;
                }).finally(() => {
                    this.saving = false;
                });
            }
        }
    }
</script>
